const state = {
    user_info: {}
};

const getters = {
    user(state) {
        return state.user_info;
    }
};

const actions = {
    setUser(context , user){
        context.commit('user', user)
    }
};

const mutations = {
    user(state, user) {
        state.user_info = user;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
